import { render } from "./QueueAnswerTimeCard.vue?vue&type=template&id=28a63a2b"
import script from "./QueueAnswerTimeCard.vue?vue&type=script&lang=js"
export * from "./QueueAnswerTimeCard.vue?vue&type=script&lang=js"

import "./QueueAnswerTimeCard.vue?vue&type=style&index=0&id=28a63a2b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__